class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.megaMenuLinks = el.querySelectorAll('.mega-menu-item');
		this.mobileLinks = el.querySelectorAll('.mobile-top-level-link-clickable');
		this.megaMenuBg = document.querySelector('.site-header__megamenu-bg');

		this.updateHeaderHeightVar();
		this.setupEventHandlers();
		this.removeSearchValue();
	}

	setupEventHandlers() {
		const body = document.querySelector('body');
		const html = document.documentElement;
		// mobile menu button handler
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');
		const mobileMenuContainer = this.el.querySelector('.site-header__mobile-container');

		if (btnMobileMenu && mobileMenuContainer) {
			// Closed by default: its internal links cannot receive Tab.
			mobileMenuContainer.inert = true;

			btnMobileMenu.addEventListener('click', () => {
				const isOpen = document.documentElement.classList.toggle(
					'mobile-menu-active'
				);

				btnMobileMenu.setAttribute(
					'aria-expanded',
					isOpen ? 'true' : 'false'
				);

				mobileMenuContainer.inert = !isOpen;
			});

			document.addEventListener('keydown', (e) => {
				if (
					e.key !== 'Tab' ||
					!document.documentElement.classList.contains('mobile-menu-active')
				) {
					return;
				}

				const focusableElements = Array.from(
					mobileMenuContainer.querySelectorAll(
						'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
					)
				).filter((element) => element.getClientRects().length > 0);

				if (!focusableElements.length) {
					e.preventDefault();
					btnMobileMenu.focus();
					return;
				}

				const firstFocusable = focusableElements[0];
				const lastFocusable = focusableElements[focusableElements.length - 1];

				if (
					e.shiftKey &&
					document.activeElement === btnMobileMenu
				) {
					e.preventDefault();
					lastFocusable.focus();
					return;
				}

				if (
					!e.shiftKey &&
					document.activeElement === lastFocusable
				) {
					e.preventDefault();
					btnMobileMenu.focus();
				}
			});
		}

		// mobile menu handler 
		if (this.mobileLinks) {
			this.mobileLinks.forEach((link) => {
				link.addEventListener('click', (e) => {
					e.preventDefault();
					this.mobileLinks.forEach((closeLink) => {
						if (closeLink !== link) {
							closeLink.classList.remove('active');
						}
					});
					link.classList.toggle('active');
				});
			});
		}

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// update header height on scroll
		window.addEventListener('scroll', () => this.updateHeaderHeightVar());

		// mega menu handler 
		if (this.megaMenuLinks) {
			this.megaMenuLinks.forEach((link) => {
				link.addEventListener('click', () => {

					this.megaMenuLinks.forEach((megaMenuLink) => {
						if (megaMenuLink !== link) {
							megaMenuLink.setAttribute('aria-expanded', false);
							megaMenuLink.classList.remove('active');
						}
					});

					if (link.classList.contains('active')) {
						body.classList.remove('no-scroll');
						html.classList.remove('no-scroll');
						link.setAttribute('aria-expanded', false);
						link.classList.remove('active');
						this.megaMenuBg.classList.remove('active');
						this.el.classList.remove('site-header--menu-active');
					} else {
						body.classList.add('no-scroll');
						html.classList.add('no-scroll');
						link.setAttribute('aria-expanded', true);
						link.classList.add('active');
						this.megaMenuBg.classList.add('active');
						this.el.classList.add('site-header--menu-active');
					}

				});
			});

			document.addEventListener('focusin', (e) => {
				const focusedEl = e.target;

				this.megaMenuLinks.forEach((link) => {
					if (!link.classList.contains('active')) {
						return;
					}

					const panelId = link.getAttribute('aria-controls');
					const panel = panelId
						? document.getElementById(panelId)
						: null;

					const focusStillInside =
						focusedEl === link ||
						panel?.contains(focusedEl);

					if (focusStillInside) {
						return;
					}

					link.setAttribute('aria-expanded', false);
					link.classList.remove('active');

					body.classList.remove('no-scroll');
					html.classList.remove('no-scroll');
					this.megaMenuBg?.classList.remove('active');
					this.el.classList.remove('site-header--menu-active');
				});
			});
		}

		if (this.megaMenuBg) {
			this.megaMenuBg.addEventListener('click', () => {
				this.megaMenuBg.classList.remove('active');
				body.classList.remove('no-scroll');
				html.classList.remove('no-scroll');
				this.el.classList.remove('site-header--menu-active');


				this.megaMenuLinks.forEach((megaMenuLink) => {
					megaMenuLink.setAttribute('aria-expanded', false);
					megaMenuLink.classList.remove('active');
				})
			})
		}

		document.addEventListener('keydown', evt => {
			if (evt.key === 'Escape') {
				this.megaMenuLinks.forEach((menu) => {
					menu.classList.remove('active');
					menu.setAttribute('aria-expanded', false);
				});

				body.classList.remove('no-scroll');
				html.classList.remove('no-scroll');
				this.megaMenuBg?.classList.remove('active');
				this.el.classList.remove('site-header--menu-active');
			}
		});

	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
	}

	removeSearchValue() {
		const searchInput = document.getElementById('searchsubmitmobile');
		if (searchInput) {
			searchInput.value = '';
		}
	}
}

export default SiteHeader;
